

export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc'
};